<script setup>
import { onMounted, onUnmounted, reactive, ref } from 'vue'
import { formatYen, nl2br } from '@/Shared/helper.js'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import IconProduct from '@/Shared/Icons/IconProduct'
import ZoomViewer from '@/Shared/ZoomViewer.vue'
const props = defineProps({
  keyindex: Number,
  brandInfo: Array,
  closeAction: Function,
  focus: Number,
  product: Object,
  year: String,
  types: String,
})
const cdata = reactive({
  offsetLeft: 0,
  currentImg: 0,
})
const panel = ref('panel')

const onResize = function () {
  cdata.offsetLeft = panel.value.parentNode.offsetLeft * -1
}
const generateImgPath = function (img, w) {
  const r = props.year
    ? props.brandInfo[0].brandPMSs3path + props.year + '/' + w + '/' + img
    : props.brandInfo[0].brandPMSs3path + w + '/' + img
  return r
}
const generateIconImgPath = function (img) {
  const r = props.brandInfo[0].brandPMSs3path + props.year + '/' + img
  return r
}
const productImages = function () {
  let r = []
  if (
    typeof props.product.productLightboxImg !== 'undefined' &&
    props.product.productLightboxImg != ''
  ) {
    r = props.product.productLightboxImg.split(',')
  }
  r.unshift(props.product.productImage)
  return r
}
const swapFocusOnZoom = function (n) {
  cdata.currentImg = n
}

const myZoomValue = function () {
  return 2
}

const checkMips = (productNewFlag) => {
  const r = (productNewFlag.includes('mips')) ? true : false
  return r
}
const checkD3o = (productNewFlag) => {
  const r = (productNewFlag.includes('d3o')) ? true : false
  return r
}

onMounted(() => {
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', onResize, { passive: true })
    cdata.offsetLeft = panel.value.parentNode.offsetLeft * -1
  }
})

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', onResize)
  }
})
</script>

<template>
  <div
    ref="panel"
    class="detailpanel"
    :style="{ left: cdata.offsetLeft + 'px', display: 'block', position: 'relative' }"
  >
    <div class="horizontalarea">
      <div class="moreinfo-close" @click="closeAction()">
        <IconProduct type="close" classname="icon-close" />
      </div>

      <div class="detailcontent grid grid-cols-1 lg:grid-cols-2">
        <div class="imagelist">
          <div class="mips-box">
            <img v-if="checkMips(product.productNewFlag)" :src="generateIconImgPath('MIPS.png')" alt="mips" />
          </div>
          <div class="d3o-box">
            <img v-if="checkD3o(product.productNewFlag)" :src="generateIconImgPath('D3O.jpg')" alt="d30" />
          </div>
          <div class="zoom-image-wrap">
            <span v-for="(z, zindex) in productImages()" :key="zindex" class="slideimg">
              <ZoomViewer
                v-if="cdata.currentImg == zindex"
                :zoom-amount="myZoomValue()"
                :regular="generateImgPath(productImages()[zindex], 500)"
                :zoom="generateImgPath(productImages()[zindex], 1200)"
              >
                <img
                  :src="generateImgPath(productImages()[zindex], 1200)"
                  :alt="product.productNameJ"
                  class="block relative mx-auto"
                />
              </ZoomViewer>
            </span>
          </div>
          <ul class="thum-image-wrap">
            <li v-for="(i, index) in productImages()" :key="index">
              <div @click="swapFocusOnZoom(index)">
                <img :src="generateImgPath(i, 500)" alt="" />
              </div>
            </li>
          </ul>
        </div>

        <div class="info">
          <div class="inner">
            <div class="name">
              <template v-if="types == 'v3'">
                <h3 class="product-name">{{ product.productName }} {{ product.productColor }}</h3>
              </template>
              <template v-else>
                <h3 class="product-name">{{ product.productNameJ }}</h3>
                <h4 class="product-name-en">{{ product.productName }}</h4>
              </template>
            </div>

            <p class="price">
              <span v-html="formatYen(product.productPrice)" /><span class="jp">（税込）</span>
            </p>
            <p v-if="product.productColor" class="material">
              カラー : {{ product.productColor }}
            </p>
            <p v-if="product.productSpec" class="spec">
              スペック : {{ product.productSpec }}
            </p>
            <p v-if="product.productSize" class="size">
              サイズ : {{ product.productSize }}
            </p>
            <p v-if="product.productMaterial" class="material">
              マテリアル : {{ product.productMaterial }}
            </p>
            <p v-if="product.productOrigin != ''" class="material">
              生産国 : {{ product.productOrigin }}
            </p>
            <p v-if="product.productInfo != ''" class="description" v-html="nl2br(product.productInfo)" />

            <template v-if="product.productEclink">
              <ButtonRounded class="sm:w-[250px]" text="オンラインストア" icon="external" :url="product.productEclink" />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
